import styled from 'styled-components'

export const OptionsContainer = styled.div`
  padding: 1.875rem 0rem;
  margin: 1.5625rem 0rem;
  border-radius: 0.25rem;
  background-color: ${props =>
    props.theme.colorVars.multichoice.optionsContainer.background};
`
